/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
// import { Dimensions } from 'react-native';
import { t } from 'i18next';

import "./ShuttleTableTab.css"
import ShuttleTable1 from './ShuttleTable1.jsx';
import ShuttleTable2 from './ShuttleTable2.jsx';

import shuttlemap from '../../images/shuttle_map.svg'
import shuttlemap_en from '../../images/shuttle_map_en.svg'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const ShuttleTableTab = () => {    
    return(
        <div className="sect-01-box-01-hotel">
            <div style={{marginBottom:"3%"}}>
            <ShuttleTable1/>
            </div>
            <ShuttleTable2/>
        </div>
    )
}

export default ShuttleTableTab;